export enum PaymentType {
  CARD = 'CARD',
  VOUCHER = 'VOUCHER',
  EUROBONUS = 'EUROBONUS',
  INTERNETBANKING = 'INTERNETBANKING',
  WALLET = 'WALLET',
  KLARNA = 'KLARNA',
  TRAVELACCOUNT = 'TRAVELACCOUNT',
  SWISH = 'SWISH',
}

export enum UpdateMode {
  CHANGE = 'CHANGE',
  KEEP_FLIGHTS = 'KEEP_FLIGHTS',
}
